import React from 'react';

import { Alert } from '@mui/material';

import type { AlertProperties } from '../AlertContainer.types';

export const AlertMessage: React.FC<AlertProperties> = ({
  dataTest = 'alert_message',
  children,
  severity,
}) => {
  return (
    <Alert
      data-testid={dataTest}
      severity={severity}
      variant='outlined'
      sx={{ backgroundColor: 'background.default', width: '100%' }}
    >
      {children}
    </Alert>
  );
};
